import { COMMON_PAGE_LIMIT, prepareIdsForChunking } from '@wix/a11y-wizard-common';
import { queryDraftPosts } from '@wix/ambassador-blog-v3-draft/http';
import { Field } from '@wix/ambassador-blog-v3-draft/types';
const REQUIRED_POST_STATUS = ['SCHEDULED', 'PUBLISHED'];
export const fetchDraftPosts = async (httpClient, errorHandler, ids) => {
  const {
    withErrorHandler
  } = errorHandler;
  const allBlogPosts = [];
  await withErrorHandler(async () => {
    const idChunks = prepareIdsForChunking(ids, COMMON_PAGE_LIMIT);
    const chunkPromises = idChunks.map(async idChunk => {
      const chunkPosts = [];
      let offset = 0;
      let hasMore = true;
      do {
        const {
          data: {
            draftPosts,
            pagingMetadata
          }
        } = await httpClient.request(queryDraftPosts({
          fieldsets: [Field.RICH_CONTENT],
          query: {
            filter: {
              ...(idChunk.length > 0 ? {
                id: {
                  $in: idChunk
                }
              } : {}),
              status: {
                $in: REQUIRED_POST_STATUS
              }
            },
            paging: {
              limit: COMMON_PAGE_LIMIT,
              offset
            }
          }
        }));
        chunkPosts.push(...(draftPosts ?? []));
        offset += COMMON_PAGE_LIMIT;
        hasMore = (pagingMetadata == null ? void 0 : pagingMetadata.hasNext) ?? false;
      } while (hasMore);
      return chunkPosts;
    });
    const results = await Promise.all(chunkPromises);
    allBlogPosts.push(...results.flat());
  }, {
    errorCodesMap: {}
  });
  return allBlogPosts;
};
//# sourceMappingURL=fetch-draft-posts.js.map